import { render, staticRenderFns } from "./NewsCommon.vue?vue&type=template&id=902f3ba8&"
import script from "./NewsCommon.vue?vue&type=script&lang=js&"
export * from "./NewsCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports